/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StoreProfileCategory
 */
export interface StoreProfileCategory {
    /**
     * 
     * @type {string}
     * @memberof StoreProfileCategory
     */
    key: string;
    /**
     * 
     * @type {string}
     * @memberof StoreProfileCategory
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof StoreProfileCategory
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof StoreProfileCategory
     */
    icon: string;
}

/**
 * Check if a given object implements the StoreProfileCategory interface.
 */
export function instanceOfStoreProfileCategory(value: object): value is StoreProfileCategory {
    if (!('key' in value) || value['key'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('icon' in value) || value['icon'] === undefined) return false;
    return true;
}

export function StoreProfileCategoryFromJSON(json: any): StoreProfileCategory {
    return StoreProfileCategoryFromJSONTyped(json, false);
}

export function StoreProfileCategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): StoreProfileCategory {
    if (json == null) {
        return json;
    }
    return {
        
        'key': json['key'],
        'name': json['name'],
        'description': json['description'],
        'icon': json['icon'],
    };
}

export function StoreProfileCategoryToJSON(json: any): StoreProfileCategory {
    return StoreProfileCategoryToJSONTyped(json, false);
}

export function StoreProfileCategoryToJSONTyped(value?: StoreProfileCategory | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'key': value['key'],
        'name': value['name'],
        'description': value['description'],
        'icon': value['icon'],
    };
}

